import React from 'react';

const IconArrowTop = ({ fill = 'E6E4FF' }) => {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.88806 20.8191L16.3068 7.40037L17.2312 18.489L20.7183 18.1995L19.3583 1.87397L3.03285 0.51403L2.74329 4.00113L13.832 4.92549L0.413191 18.3443L2.88806 20.8191Z"
        fill={fill}
      />
    </svg>
  );
};

export default IconArrowTop;
